import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function PolicyModal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-42">
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-43">
        <div className="sticky top-0 bg-slate-900 border-b border-slate-800 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-44">
          <h2 className="text-lg font-semibold text-white" data-id="element-45">{title}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-800" aria-label="Cerrar" data-id="element-46">
            <XIcon className="w-5 h-5" data-id="element-47" />
          </button>
        </div>
        <div className="px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-48">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="w-full bg-slate-950 py-12 px-6 text-center border-t border-slate-800" data-id="element-49">
        <div className="max-w-4xl mx-auto" data-id="element-50">
          <p className="text-slate-500 text-sm mb-6 leading-relaxed" data-id="element-51">
            Descargo de responsabilidad: Esta guía es una herramienta de
            primeros auxilios emocionales y no sustituye el consejo, diagnóstico
            o tratamiento médico profesional. Si tú o tu hijo experimentan una
            emergencia médica, llama al 911 o acude a la sala de emergencias más
            cercana inmediatamente.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-52">
            <button onClick={() => setOpenModal('privacy')} className="text-slate-500 hover:text-slate-300 text-sm underline underline-offset-2 transition-colors" data-id="element-53">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-54">|</span>
            <button onClick={() => setOpenModal('terms')} className="text-slate-500 hover:text-slate-300 text-sm underline underline-offset-2 transition-colors" data-id="element-55">
              Términos y Condiciones
            </button>
          </div>
          <div className="text-slate-600 text-sm" data-id="element-56">
            &copy; {new Date().getFullYear()} Ansiedad Exprés. Todos los
            derechos reservados.
          </div>
        </div>
      </footer>

      {openModal === 'privacy' && <PolicyModal title="Política de Privacidad" onClose={() => setOpenModal(null)} data-id="element-57">
          <p data-id="element-58">
            <strong data-id="element-59">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-60">
            En Ansiedad Exprés, nos comprometemos a proteger tu privacidad y la
            de tu familia. Esta política describe cómo recopilamos, usamos y
            protegemos tu información personal.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-61">
            1. Información que recopilamos
          </h3>
          <p data-id="element-62">
            Recopilamos información que nos proporcionas directamente, como tu
            nombre, dirección de correo electrónico y datos de pago al realizar
            una compra. No recopilamos información de menores de edad de forma
            directa.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-63">
            2. Uso de la información
          </h3>
          <p data-id="element-64">
            Utilizamos tu información para procesar transacciones, enviar
            materiales adquiridos, comunicarnos contigo sobre tu compra y
            mejorar nuestros servicios.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-65">
            3. Protección de datos
          </h3>
          <p data-id="element-66">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración o destrucción.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-67">
            4. Compartir información
          </h3>
          <p data-id="element-68">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros, excepto proveedores de servicios necesarios para operar
            nuestro negocio (procesadores de pago, servicios de email).
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-69">5. Cookies</h3>
          <p data-id="element-70">
            Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
            navegación. Puedes configurar tu navegador para rechazar cookies.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-71">6. Contacto</h3>
          <p data-id="element-72">
            Si tienes preguntas sobre esta política de privacidad, puedes
            contactarnos a través de nuestro correo electrónico de soporte.
          </p>
        </PolicyModal>}

      {openModal === 'terms' && <PolicyModal title="Términos y Condiciones" onClose={() => setOpenModal(null)} data-id="element-73">
          <p data-id="element-74">
            <strong data-id="element-75">Última actualización:</strong> Abril 2026
          </p>
          <p data-id="element-76">
            Al acceder y utilizar este sitio web y adquirir nuestros productos,
            aceptas los siguientes términos y condiciones.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-77">
            1. Productos digitales
          </h3>
          <p data-id="element-78">
            Los productos ofrecidos son guías digitales descargables. Una vez
            completada la compra, recibirás acceso inmediato al material. Debido
            a la naturaleza digital del producto, no se aceptan devoluciones una
            vez descargado el contenido.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-79">2. Uso permitido</h3>
          <p data-id="element-80">
            El contenido adquirido es para uso personal y familiar únicamente.
            Queda prohibida la reproducción, distribución o reventa del material
            sin autorización expresa.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-81">
            3. Descargo de responsabilidad
          </h3>
          <p data-id="element-82">
            El contenido proporcionado es informativo y educativo. No constituye
            asesoramiento médico, psicológico ni profesional. Consulta siempre
            con un profesional de la salud calificado para situaciones médicas.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-83">
            4. Propiedad intelectual
          </h3>
          <p data-id="element-84">
            Todo el contenido, diseño, textos e imágenes de este sitio y los
            productos digitales son propiedad de Ansiedad Exprés y están
            protegidos por las leyes de propiedad intelectual.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-85">5. Modificaciones</h3>
          <p data-id="element-86">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos inmediatamente después de su
            publicación en el sitio.
          </p>
          <h3 className="text-white font-medium pt-2" data-id="element-87">6. Contacto</h3>
          <p data-id="element-88">
            Para cualquier consulta sobre estos términos, puedes comunicarte con
            nosotros a través de nuestro correo electrónico de soporte.
          </p>
        </PolicyModal>}
    </>;
}